import React from 'react'

import {
  BasicQuality,
  PremiumQuality,
  ProQuality,
  AIGenerated,
  Designer,
  Icon,
  Tooltip,
  Verified,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { ADVANCED_FILTER, QUALITY_LEVEL, CONTENT_SOURCE } from 'Pods/SearchPage/Store/constants'

export const qualityLevels = [
  { value: QUALITY_LEVEL.ANY, labelKey: 'any' },
  { value: QUALITY_LEVEL.BASIC, labelKey: 'basic', icon: BasicQuality },
  { value: QUALITY_LEVEL.PREMIUM, labelKey: 'premium', icon: PremiumQuality },
  { value: QUALITY_LEVEL.PRO, labelKey: 'pro', icon: ProQuality },
]

export const contentSources = [
  { value: CONTENT_SOURCE.ALL, labelKey: 'all' },
  { value: CONTENT_SOURCE.AI_GENERATED, labelKey: 'ai_generated', icon: AIGenerated },
  { value: CONTENT_SOURCE.HUMAN_CREATED, labelKey: 'human_created', icon: Designer },
]

export const CGT_STANDARD_SELECTED = [ADVANCED_FILTER.CGT_STANDARD_ONLY]

// The badge lives inside the checkbox's <label>. On touch the tooltip opens on click, and a native
// click there would also toggle the checkbox, whose follow-up click on the input then closes the
// tooltip through react-tooltip's global click-off. Prevent both.
export const handleTooltipTriggerClick = (event) => {
  event.preventDefault()
  event.stopPropagation()
}

// The dropdown, the More filters overflow and the mobile drawer can mount this at the same time, so
// each caller passes its own tooltipId.
export const getCgtStandardConfig = (translate, tooltipId) => [{
  label: '',
  filters: [{
    value: ADVANCED_FILTER.CGT_STANDARD_ONLY,
    label: (
      <span className="filter-wrapper__option--with-icon">
        <span>{translate('search_page.filters.advanced.cgt_standard')}</span>
        <Tooltip
          id={tooltipId}
          content={translate('search_page.filters.advanced.cgt_standard_tooltip')}
          place="bottom"
          tooltipClassName="quality-filter__tooltip"
        >
          <span className="quality-filter__tooltip-trigger" onClick={handleTooltipTriggerClick}>
            <Icon notSpaced svgComponent={Verified} color="primary" size="small" />
          </span>
        </Tooltip>
      </span>
    ),
  }],
}]
